// extracted by mini-css-extract-plugin
export default {"app":"app--FCd84","info-popup":"info-popup--ONOFS","infoPopup":"info-popup--ONOFS"};